module.exports = __webpack_public_path__ + "static/media/close.978f14b0.svg";